// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2d6GM","col":"styles_col__3RQ9t","fulfillmentStatus":"styles_fulfillmentStatus__2RGlB","emailCol":"styles_emailCol__27LSi"};